// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1bURf","row":"ProcedureTreatmentSummary_row__pOliC"};